/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BranchWithOrderCountAndNetSales } from './BranchWithOrderCountAndNetSales';
import {
    BranchWithOrderCountAndNetSalesFromJSON,
    BranchWithOrderCountAndNetSalesFromJSONTyped,
    BranchWithOrderCountAndNetSalesToJSON,
    BranchWithOrderCountAndNetSalesToJSONTyped,
} from './BranchWithOrderCountAndNetSales';

/**
 * 
 * @export
 * @interface BusinessReportBranchesWithOrderCountAndNetSalesResponse
 */
export interface BusinessReportBranchesWithOrderCountAndNetSalesResponse {
    /**
     * 
     * @type {Array<BranchWithOrderCountAndNetSales>}
     * @memberof BusinessReportBranchesWithOrderCountAndNetSalesResponse
     */
    data: Array<BranchWithOrderCountAndNetSales>;
}

/**
 * Check if a given object implements the BusinessReportBranchesWithOrderCountAndNetSalesResponse interface.
 */
export function instanceOfBusinessReportBranchesWithOrderCountAndNetSalesResponse(value: object): value is BusinessReportBranchesWithOrderCountAndNetSalesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BusinessReportBranchesWithOrderCountAndNetSalesResponseFromJSON(json: any): BusinessReportBranchesWithOrderCountAndNetSalesResponse {
    return BusinessReportBranchesWithOrderCountAndNetSalesResponseFromJSONTyped(json, false);
}

export function BusinessReportBranchesWithOrderCountAndNetSalesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessReportBranchesWithOrderCountAndNetSalesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BranchWithOrderCountAndNetSalesFromJSON)),
    };
}

export function BusinessReportBranchesWithOrderCountAndNetSalesResponseToJSON(json: any): BusinessReportBranchesWithOrderCountAndNetSalesResponse {
    return BusinessReportBranchesWithOrderCountAndNetSalesResponseToJSONTyped(json, false);
}

export function BusinessReportBranchesWithOrderCountAndNetSalesResponseToJSONTyped(value?: BusinessReportBranchesWithOrderCountAndNetSalesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BranchWithOrderCountAndNetSalesToJSON)),
    };
}

